import PhotoPreviewPopup from './PhotoPreviewPopup';

export default PhotoPreviewPopup;
